import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { map, switchMap, tap } from 'rxjs';
import { LocalContextService } from '../../shared/services/local-context.service';
import { DialogTotemComponent } from '../../features/totem/dialog-totem/dialog-totem.component';
import { LocalService } from '../../shared/services/local.service';

export const totemLocalGuard: CanActivateFn = () => {
  const localContext = inject(LocalContextService);

  if (localContext.getCurrentLocalId()) {
    return true;
  }

  const dialog = inject(MatDialog);
  const localService = inject(LocalService);

  return localService.getAll().pipe(
    switchMap((result) => {
      if (!result.success || !result.content) {
        return [false];
      }

      const localList = result.content.map((local) => ({
        text: local.nome,
        value: local.id,
      }));

      const dialogRef = dialog.open(DialogTotemComponent, {
        disableClose: true,
        data: { localList },
      });
      return dialogRef.afterClosed();
    }),
    map((selectedLocalId) => {
      if (selectedLocalId) {
        localContext.setLocal(selectedLocalId);
        return true;
      }

      return false;
    }),
  );
};
